// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n  .AutoFocus__container__oJa3R:focus {\n    outline: none\n  }\n", "",{"version":3,"sources":["webpack://./components/AutoFocus/style.css"],"names":[],"mappings":";EACE;IACE;EACF","sourcesContent":[".container {\n  &:focus {\n    outline: none\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "AutoFocus__container__oJa3R"
};
export default ___CSS_LOADER_EXPORT___;
